// store
import {
  SET_SOCIAL,
} from "../../store/actions/social";

const state = {
  social: ['vk', 'tw', 'fb', 'ig', 'gs', 'tg', 'yt', 'ok']
};

const getters = {
  socialList: state => state.social,
};

const actions = {
  [SET_SOCIAL]: ({commit}, val) => {
    commit(SET_SOCIAL, val);
  },
};

const mutations = {
  [SET_SOCIAL]: (state, val) => {
    if (state.social.includes(val)) {
      if (state.social.length > 1) {
        state.social = state.social.filter(item => item !== val);
      }
    } else {
      state.social.push(val);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
